import { render, staticRenderFns } from "./RatingType.vue?vue&type=template&id=5feb19a0&scoped=true&"
import script from "./RatingType.vue?vue&type=script&lang=js&"
export * from "./RatingType.vue?vue&type=script&lang=js&"
import style0 from "./RatingType.vue?vue&type=style&index=0&id=5feb19a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb19a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VIcon,VInput,VRadio,VRadioGroup,VRating})
